import { httpRawClient, type TSessionToken } from '@core/http-client'
import { Logger } from '@core/logger'

const SSR_SESSION_URL = '/auth/session'

// `httpRawClient`, not `httpClient`: this route is served by the web tier at the current origin,
// while `httpClient` is prefixed with `app.domains.api`.
export const openSsrSession = async (token: TSessionToken): Promise<boolean> => {
    try {
        await httpRawClient.post(SSR_SESSION_URL, {
            headers: { Authorization: `${token.tokenType} ${token.accessToken}` },
            json: {
                refreshToken: token.refreshToken ?? '',
                expiresIn: token.accessTokenExpires ?? 0,
            },
        })

        return true
    } catch (error) {
        // Non-fatal: the SPA is signed in either way, the next hard load just renders as a guest.
        Logger.error('POST auth/session error:', { error })

        return false
    }
}

export const closeSsrSession = async (): Promise<void> => {
    try {
        await httpRawClient.delete(SSR_SESSION_URL)
    } catch (error) {
        Logger.error('DELETE auth/session error:', { error })
    }
}
